import styled from 'styled-components';

export const RoomsContainer = styled.div`
  width: 100%;
  margin-top: 50px;
  padding: 16px;
`;